export type WithClassName = {
  className?: string
}

export type Status = 'success' | 'warning' | 'alert'

export const JSON_SPACE_COUNT = 2

export const validJson = (formValue: string) => {
  try {
    const parseResult = JSON.parse(formValue)
    if (parseResult) {
      return true
    }
  } catch (_e) {
    return false
  }
  return false
}
